import alasql from 'alasql'
import moment from 'moment'

const { $ } = window

const Calculate = {
	getSCNData: (id, tables) => {
		let datasx = [];
		for(let i in tables) {
			let tval = tables[i];
			let from = tval.dt.split("-");
			let f = from[1] + "/" + from[2] + "/" + from[0]

			f = new Date(f).getTime()

			if (tval.scenario_id === id) {
				if (tval.vami !== "") {
					datasx.push([f, parseFloat(tval.vami)])
				}
			}

		}

		return datasx;
	},

	getDataForstacA: (dates, st, scn_port) => {
		var alldata = []
		var res = alasql('SELECT SUM(CAST(allocation as FLOAT)) as allocation,dt FROM ?  where fund_asset_class_focus ="' + st + '" GROUP BY dt', [scn_port])

		$.each(dates, function(k, v) {
			var f1 = parseInt(moment(v, 'YYYY-MM-DD').format('x'))
			$.each(res, function(kk, vv) {
				if (vv.dt == v) {
					alldata.push([f1,parseFloat(vv.allocation)])
				}
			})
		})

		return alldata;
	},

	getDataForstac: (dates, st, scn_port) => {

		let alldata = []
		let res = alasql('SELECT SUM(CAST(allocation as FLOAT)) as allocation,dt,style FROM ?  where style ="' + st + '" GROUP BY dt,style', [scn_port])

		var dateexists = 0;
		$.each(dates, function(k, v) {
			$.each(res, function(kk, vv) {
				var daformat = parseInt(moment(v, 'YYYY-MM-DD').format('x'))
				if (vv.dt == v) {
					alldata.push([daformat,parseFloat(vv.allocation)])
				}
			})
		})

		return alldata;
	},

	getDataForskittle1:(dates, st, scn_port) => {
		let alldata = []
		var res = alasql('SELECT SUM(CAST(allocation as FLOAT)) as allocation,dt,fund_asset_class_focus FROM ?  where fund_asset_class_focus ="' + st + '" GROUP BY dt,fund_asset_class_focus', [scn_port])
		
		// var dateexists = 0;
		// $.each(dates, function(k, v) {
		// 	$.each(res, function(kk, vv) {
		// 		var daformat = parseInt(moment(v, 'YYYY-MM-DD').format('x'))
		// 		if (vv.dt == v) {
		// 			alldata.push([daformat,parseFloat(vv.allocation)])
		// 		}
		// 	})
		// })
		
		return res;		
	},
	
	getDataForAssetClassStyle(dat) {
		let dates = [];
		let styles = [];
		let ASTC = [];


		var fund_name = ''
		$.each(dat.getPortfolioVami, function(key, val) {
			fund_name = val.scenario_name
			return false;
		});

		var bm_name = ''
		$.each(dat.getBenchmarkVami, function(key, val) {
			bm_name = val.benchmark_name
			return false;
		});

		var arc_name = ''
		$.each(dat.getARCVami, function(key, val) {
		    arc_name = val.benchmark_name
		    return false;
		});

		var datespie = []

		/***BAR CHART****/

		var scn_port = dat.getPortfolioData

		$.each(scn_port, function(k, v) {
			if (dates.indexOf(v.dt) == -1) {
				dates.push(v.dt)
			}

			if (styles.indexOf(v.style) == -1) {
				styles.push(v.style)
			}

			if (ASTC.indexOf(v.fund_asset_class_focus) == -1) {
				ASTC.push(v.fund_asset_class_focus)
			}
		});


		var seriesOptions = []
		$.each(styles, function(k, v) {
			var sdata = Calculate.getDataForstac(dates, v, scn_port);
			let fund_names = alasql("SELECT DISTINCT fund_name FROM ? WHERE style == '" + v + "'", [scn_port])
			seriesOptions.push({
				name: fund_names[0].fund_name,
				data: sdata
			})
		});

		var seriesOptionsA = []
		$.each(ASTC, function(k, v) {
			var sdata = Calculate.getDataForstacA(dates, v, scn_port);
			seriesOptionsA.push({
				name: v,
				data: sdata
			})
		});

		return { seriesOptions, seriesOptionsA }
	}
}

export default Calculate


// WEBPACK FOOTER //
// ./src/helper/calculate.helper.js